import React, { useState, useEffect } from "react";
import { Button, DatePicker, message, Select, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import useMembersStore from "../../store/members.store";
import "./filterresumedatabase.scss"; 
import useSettingstore from "../../store/settings.store";
import dayjs from "dayjs";
import useResumeDataBaseStore from "../../store/resumedatabasesearch.store";
import { FILTER_DURATION_OPTIONS } from "../../helper/categoryconstants";

function FilterResumeDataBase({
  filtername,
  handleFilter,
  enableRange = false,
  enableDuration = false,
  enableResumeUpgrade = false,
  enableResumeIndexed = false,
  enableResumeYear = false,
  enableResumeMonth = false,
  enableTeamMember = false,
  initDuration,
  initResumeUpgrade,
  initResumeIndexed,
  initResumeYear,
  initResumeMonth,
  initTeamMember,
  pageNo,
  pageSize,
  setCurrentPage
}) {
  const [filterDuration, setDuration] = useState("All");
  const [filterResumeUpgrade, setResumeUpgrade] = useState(initResumeUpgrade);// all
  const [filterResumeIndexed, setResumeIndexed] = useState(initResumeIndexed);// all
  const [filterResumeYear, setResumeYear] = useState(initResumeYear);// all
  const [filterResumeMonth, setResumeMonth] = useState(initResumeMonth);// all
  const [filterStartTs, setStartTs] = useState("");
  const [filterEndTs, setEndTs] = useState("");
  const { teamMembers} = useMembersStore();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const allOptions = { value: "All", label: "All" };
  const [sourcingList, setSourcingList] = useState([allOptions]);
  const {resumeDataBaseUpdateFlag,resetResumeDataBaseUpdateFlag } = useResumeDataBaseStore();

  const monthsDATA = [
    { value: "All", label: "All" },
    { value: "January", label: "January" }, 
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" }, 
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },    
  ];


  const teamData = teamMembers?.map((member, idx) => {
        return {
            value:member?.qhuid,
            label:member.username,
        };
  });
  const userData = JSON.parse(localStorage.getItem("userDetails"));
  const [filterTeamMember, setTeamMember] = useState(userData.qhuid);   

  useEffect(() => {
    // Call API whenever page or pageSize changes
      getDataforFilter();
  }, [pageNo, pageSize]);

  useEffect(() => {
    if(resumeDataBaseUpdateFlag){
      getDataforFilter();
      resetResumeDataBaseUpdateFlag()
    }
  }, [resumeDataBaseUpdateFlag]);

  const initFilterfromStore = () => {
      var filterObj = getSettingByKey(filtername)
      //console.log("filterObj",filterObj)
      if( filterObj != null){
       if(filterObj.value.filterDuration != undefined) 
        setDuration(filterObj.value.filterDuration)
       if(filterObj.value.resumeUpgrade != undefined)
        setResumeUpgrade(filterObj.value.resumeUpgrade)  
       if(filterObj.value.resumeIndexed != undefined)
        setResumeIndexed(filterObj.value.resumeIndexed)
       if(filterObj.value.resumeYear != undefined)
        setResumeYear(filterObj.value.resumeYear) 
       if(filterObj.value.resumeMonth != undefined)
        setResumeMonth(filterObj.value.resumeMonth) 
      }
  };

  const getDataforFilter = () => {
    let encodedJsonValues = {};

    encodedJsonValues.resumeindexed = filterResumeIndexed;
    encodedJsonValues.resumeupgrade = filterResumeUpgrade;
    encodedJsonValues.resumeyear = filterResumeYear;
    encodedJsonValues.resumemonth = filterResumeMonth;
  
    if (enableRange) {
       encodedJsonValues.isduration = false;
       encodedJsonValues.startts = parseInt(filterStartTs, 10);
       encodedJsonValues.endts = parseInt(filterEndTs, 10);
    }else 

    encodedJsonValues.isduration = true;
    encodedJsonValues.duration = filterDuration

    encodedJsonValues.teammemberuid = filterTeamMember;

    encodedJsonValues.pagenum = pageNo;
    encodedJsonValues.pagesize = pageSize;
    handleFilter(encodedJsonValues);
  };


   const handleUpdateFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues.resumeindexed = filterResumeIndexed;
    encodedJsonValues.resumeupgrade = filterResumeUpgrade;
    encodedJsonValues.resumeyear = filterResumeYear;
    encodedJsonValues.resumemonth = filterResumeMonth;    

    if (enableRange) {
       encodedJsonValues.isduration = false;
       encodedJsonValues.startts = parseInt(filterStartTs, 10);
       encodedJsonValues.endts = parseInt(filterEndTs, 10);
    }else 
       encodedJsonValues.isduration = true;
       encodedJsonValues.duration = filterDuration
  

    encodedJsonValues.teammemberuid = filterTeamMember;

    //reset to first page whenever filter is updated
    encodedJsonValues.pagenum = 1;
    encodedJsonValues.pagesize = pageSize;
    setCurrentPage(1);
    handleFilter(encodedJsonValues);

    //update store
    encodedJsonValues.filterDuration = filterDuration;
    let filterSettings = {"key":filtername, "value":encodedJsonValues}
    addOrUpdateSetting(filterSettings)
  };

  useEffect(() => {

    const todayEndTs = dayjs().endOf("day").unix();
    const yesterdayStartTs = dayjs().subtract(1, "day").startOf("day").unix();

    setEndTs(todayEndTs)
    setStartTs(yesterdayStartTs)
      
    initFilterfromStore()
    setSourcingList([...teamData,allOptions])

  }, []);


  const handleTeamMember = (value) => {
    setTeamMember(value);
  };

  const handleDuration = (value) => {
    setDuration(value);
  };

  const handleResumeUpgrade = (value) => {
    setResumeUpgrade(value);
  } 
  const handleResumeIndexed = (value) => {
    setResumeIndexed(value);
  }   
  const handleResumeYear = (dates,dateStrings) => {
    console.log(dateStrings); // "2024"
    setResumeYear(dateStrings || null);
  }
  const handleResumeMonth = (value) => {
    setResumeMonth(value);
  }

  const today = dayjs();
  const yesterday = dayjs().subtract(1, "day");
  const { RangePicker } = DatePicker;
  const [dateRange, setDateRange] = useState([yesterday,today]); 

  const isEnable = () =>{
    var isE = enableDuration || enableResumeUpgrade || enableResumeIndexed || enableResumeYear || enableResumeMonth || enableTeamMember || enableRange;
    return isE
  }
  const disabledDate = (current) => {
    if (!dateRange || dateRange.length === 0) return false;

    const [start, end] = dateRange;

    // If selecting end date
    if (start && !end) {
      return (
        current.isBefore(start.subtract(90, "day")) ||
        current.isAfter(start.add(90, "day"))
      );
    }

    // If selecting start date
    if (!start && end) {
      return (
        current.isBefore(end.subtract(90, "day")) ||
        current.isAfter(end.add(90, "day"))
      );
    }

    return false;
  };  
  
  const handlDateRange = (dates,dateStrings) =>{
    if (!dates) {
      // cleared
      setDateRange(null);
      setStartTs(null);
      setEndTs(null);
      return;
    }

    const diffDays = dates[1].diff(dates[0], "day");
    if (diffDays > 90) {
      message.error("Date range cannot exceed 90 days");
      return;
    }    
    const start = dates[0].startOf("day").unix(); // start of day
    const end = dates[1].endOf("day").unix();     // end of day
    
    setDateRange(dates);
    setStartTs(start)
    setEndTs(end)

    //console.log("Selected dates:", dates);
    //console.log("Formatted:", dateStrings);    
  }

  return (
    <>
      <div className="resumedatabase-filter"> 
        <div className="teamTask-filter-item-wrapper">
          {enableResumeYear && (
            <>
              <div className="teamTask-filter-item-label">Resume Year</div>
              <div className="teamTask-filter-item">
                <Space direction="horizontal" size={12}>
                    <DatePicker
                      picker="year"   // 👈 IMPORTANT
                      format="YYYY"
                      value={filterResumeYear? dayjs(filterResumeYear, "YYYY") : null}
                      onChange={(dates, dateStrings) => handleResumeYear(dates,dateStrings)}
                    />                     
                </Space>  
              </div>
            </>
          )}
        </div>           
        <div className="teamTask-filter-item-wrapper">
          {enableResumeMonth && (
            <>
              <div className="teamTask-filter-item-label">Resume Month</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleResumeMonth}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterResumeMonth}
                  options={monthsDATA}
                />
              </div>
            </>
          )}
        </div>           
        <div className="teamTask-filter-item-wrapper">
          {enableResumeUpgrade && (
            <>
              <div className="teamTask-filter-item-label">Backend Upgrade</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleResumeUpgrade}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterResumeUpgrade}
                  options={[
                    { value: "All", label: "All" },
                    { value: "Needed", label: "Needed" },
                    { value: "Not Needed", label: "Not Needed" },
                  ]}
                />
              </div>
            </>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableResumeIndexed && (
            <>
              <div className="teamTask-filter-item-label">Resume Indexing</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleResumeIndexed}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterResumeIndexed}
                  options={[
                    { value: "All", label: "All" },
                    { value: "Done", label: "Done" },
                    { value: "Not Done", label: "Not Done" },
                  ]}
                />
              </div>
            </>
          )}
        </div>        
        <div className="teamTask-filter-item-wrapper">
          {enableTeamMember && (
            <>
              <div className="teamTask-filter-item-label">Sourced By</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleTeamMember}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterTeamMember}
                  options={sourcingList}
                />
              </div>
            </>
          )}
        </div>
        
          {enableDuration && (
            <div className="teamTask-filter-item-wrapper">
            <>
              <div className="teamTask-filter-item-label">Duration</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleDuration}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterDuration}
                  options={FILTER_DURATION_OPTIONS}
                />
              </div>
            </>
           </div>
          )
          }   
                    
        <div className="teamTask-filter-item-wrapper">
          {enableRange && (
            <>
              <div className="teamTask-filter-item-label">Range  (Max 90 Days)</div>
              <div className="teamTask-filter-item">
                <Space direction="horizontal" size={12}>
                    <RangePicker
                      value={dateRange}
                      disabledDate={disabledDate}
                      onChange={(dates, dateStrings) => handlDateRange(dates,dateStrings)}
                    />                     
                </Space>  
              </div>
            </>
          )}
        </div> 
        <div className="teamTask-filter-item-wrapper">
          <div className="teamTask-filter-item-label"></div>
          {isEnable() && (
            <div className="teamTask-filter-item" style={{ margin: "13px" }}>
              <Button onClick={handleUpdateFilter}>Update Now</Button>
            </div>
          )}
        </div>                                                    
      </div>
    </>
  );
}

export default FilterResumeDataBase;
